import React from "react";
import { Link } from "react-router-dom";
import IntroVideo from "../IntroVideo/IntroVideo";
import "./About.scss";

export default function About() {
  return (
    <div className="about-page">
      <div className="about-hero">
        <h1>🥬 About Us – Organic Greens Hub</h1>
        <p>Your trusted partner for natural, chemical-free produce from farm to table</p>
      </div>

      <IntroVideo />

      <div className="about-section">
        <h2>🌿 Who We Are</h2>
        <p>
          Organic Greens Hub is a mission-driven initiative rooted in the belief that healthy living begins with nature. 
          We are passionate cultivators, packagers, and distributors of fresh, organic leafy greens, vegetables, herbal products, 
          juices, and natural foods like jaggery and honey. Based in Hyderabad, India, our farm-to-table model ensures the 
          purest quality, right from soil to your kitchen.
        </p>
      </div>

      <div className="about-section">
        <h2>🌱 Our Journey</h2>
        <p>
          What started as a small local greens supply unit has now blossomed into a trusted brand known for natural, 
          chemical-free produce. With a deep commitment to sustainable farming and nutrient-rich foods, we now serve 
          domestic and international markets, helping individuals and families around the globe embrace a healthy lifestyle.
        </p>
      </div>

      <div className="mission-vision">
        <div className="card">
          <h3><span className="icon">💡</span> Our Vision</h3>
          <p>
            To become a globally trusted leader in organic agriculture, offering wholesome, naturally-grown foods 
            that nourish people and the planet.
          </p>
        </div>

        <div className="card">
          <h3><span className="icon">🎯</span> Our Mission</h3>
          <ul>
            <li>To promote clean eating and natural healing through organic greens and plant-based foods.</li>
            <li>To empower farmers with sustainable practices.</li>
            <li>To ensure eco-conscious packaging, fair trade, and quality assurance in everything we deliver.</li>
          </ul>
        </div>
      </div>

      <div className="offerings">
        <h2>🧪 What We Offer</h2>
        <div className="offerings-grid">
          <div className="offering-item">
            <span className="check-icon">✅</span>
            <span>Fresh Organic Greens (Spinach, Kale, Swiss Chard, and more)</span>
          </div>
          <div className="offering-item">
            <span className="check-icon">✅</span>
            <span>Vegetables & Herbal Produce</span>
          </div>
          <div className="offering-item">
            <span className="check-icon">✅</span>
            <span>Cold-Pressed Juices & Syrups</span>
          </div>
          <div className="offering-item">
            <span className="check-icon">✅</span>
            <span>Jaggery, Honey & Pickles</span>
          </div>
          <div className="offering-item">
            <span className="check-icon">✅</span>
            <span>Herbal & Medicinal Plants</span>
          </div>
          <div className="offering-item">
            <span className="check-icon">✅</span>
            <span>Export-Grade Packing & Certification (IEC, FSSAI, APEDA)</span>
          </div>
        </div>
      </div>

      <div className="about-section why-choose">
        <h2>🌍 Why Choose Us?</h2>
        <div className="reasons-grid">
          <div className="reason-item">
            <div className="reason-icon">🌾</div>
            <h4>Organic Produce</h4>
            <p>We ensure all our products meet strict organic certification standards.</p>
          </div>
          <div className="reason-item">
            <div className="reason-icon">🔬</div>
            <h4>Nutrient-Rich</h4>
            <p>Every batch is tested to ensure maximum nutritional value.</p>
          </div>
          <div className="reason-item">
            <div className="reason-icon">🚚</div>
            <h4>Timely Delivery – India & Abroad</h4>
            <p>We deliver fresh produce promptly, both domestically and internationally.</p>
          </div>
          <div className="reason-item">
            <div className="reason-icon">♻️</div>
            <h4>Eco-Friendly Practices</h4>
            <p>Sustainability is at the core of everything we do.</p>
          </div>
          <div className="reason-item">
            <div className="reason-icon">👩‍🌾</div>
            <h4>Farmer-Supported Sourcing</h4>
            <p>We work directly with farmers, ensuring fair compensation.</p>
          </div>
          <div className="reason-item">
            <div className="reason-icon">🛡️</div>
            <h4>Trusted by Families, Chefs & Businesses</h4>
            <p>Our quality has earned the trust of diverse customers.</p>
          </div>
        </div>
      </div>

      <div className="contact-section">
        <h2>📍 Our Locations</h2>
        <div className="locations-grid">
          <div className="location-item">
            <h4>Head Office</h4>
            <div className="contact-info">
              <p><strong>Organic Greens Hub</strong></p>
              <p>Plot No. 142, First Floor,</p>
              <p>Raghavendra Nagar, Jillelaguda,</p>
              <p>Hyderabad – 500097, Telangana, India</p>
              <p>📞 +91 9491657949</p>
            </div>
          </div>
          
          <div className="location-item">
            <h4>Branch Office</h4>
            <div className="contact-info">
              <p><strong>Organic Greens Hub</strong></p>
              <p>Opp Candeur, Bapu Nagar,</p>
              <p>Serilingampalle (M),</p>
              <p>Hyderabad, Telangana 500019</p>
              <p>📞 +91 9390649371</p>
            </div>
          </div>
        </div>

        <div className="cta">
          <h3>🌐 Let's Grow Healthy Together!</h3>
          <p>
            Join our green revolution. Whether you're a family seeking chemical-free food or a business 
            looking to import high-quality greens, Organic Greens Hub is your trusted partner.
          </p>
          <Link to="/contact" className="cta-button">Get in Touch</Link>
        </div>
      </div>
    </div>
  );
}